import { render, staticRenderFns } from "./StagingReeferActivityIndex.vue?vue&type=template&id=132242fe&scoped=true&"
import script from "./StagingReeferActivityIndex.vue?vue&type=script&lang=js&"
export * from "./StagingReeferActivityIndex.vue?vue&type=script&lang=js&"
import style0 from "./StagingReeferActivityIndex.vue?vue&type=style&index=0&id=132242fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132242fe",
  null
  
)

export default component.exports